import React from 'react'
import { Button, Modal, Typography } from 'antd'
import styles from '../SellerApiMoySklad.module.scss'

interface ISyncLaunchModalProps {
  open: boolean
  isSubmitting: boolean
  onCancel: () => void
  onConfirm: () => void
}

const MODAL_TITLE = 'Запустить синхронизацию'
const MODAL_DESCRIPTION =
  'Мы сохраним настройки и начнем синхронизацию. Товары групп, у которых выключена загрузка, будут скрыты на сайте и получат статус «Отключен».'
const MODAL_HINT = 'Проверьте свой выбор!'
const CANCEL_TEXT = 'Отменить'
const CONFIRM_TEXT = 'Синхронизировать'

export const SyncLaunchModal: React.FC<ISyncLaunchModalProps> = ({
  open,
  isSubmitting,
  onCancel,
  onConfirm
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      width={480}
    >
      <div className={styles.syncLaunchModal}>
        <Typography.Title level={3} className={styles.syncLaunchTitle}>
          {MODAL_TITLE}
        </Typography.Title>
        <Typography.Text className={styles.syncLaunchDescription}>
          {MODAL_DESCRIPTION}
        </Typography.Text>
        <Typography.Text className={styles.syncLaunchHint}>
          {MODAL_HINT}
        </Typography.Text>
        <div className={styles.syncLaunchActions}>
          <Button size='large' onClick={onCancel}>
            {CANCEL_TEXT}
          </Button>
          <Button
            size='large'
            type='primary'
            onClick={onConfirm}
            loading={isSubmitting}
          >
            {CONFIRM_TEXT}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
